import { TextField } from '@mui/material'
import { InputProps } from './Input.types'

export const Input = ({
  ariaLabel,
  label,
  onChange,
  value,
  className,
  name,
  disabled = false,
  size,
  ...otherProps
}: InputProps) => {
  return (
    <TextField
      label={label}
      disabled={disabled}
      variant="outlined"
      value={value}
      onChange={onChange}
      size={size}
      sx={{
        '& .MuiInputBase-input': {
          paddingTop: size === 'small' ? '9px' : '15px',
          paddingBottom: size === 'small' ? '9px' : '14px',
        },
      }}
      inputProps={{
        'aria-label': ariaLabel,
        name: name,
      }}
      className={className}
      {...otherProps}
    />
  )
}
